import create from 'zustand'
import {useSymbolsGlobalState} from './SymbolsMetaDataState';
import {refreshStateDataForeignMarkets} from "./StoreUtil"; // import the new store

const addr = 'https://api.bahabin.com/quotes?market=AGR&sort_by=ord&order_by=acs';
const topItemsAddr = 'https://api.bahabin.com/quotes?market=AGR&limit=7&sort_by=ord&order_by=acs';

export const useGlobalAgricultureGlobalState = create((set, get) => ({
    agricultureList: null,
    topItems: null,
    setAgricultureList: (agricultureList) => set({agricultureList}),
    setTopItems: (topItems) => set({topItems}),
    refreshAgricultureList: async () => {
        await useSymbolsGlobalState.getState().refreshCache();
        const symbolsGlobalCache = useSymbolsGlobalState.getState().cache;
        await refreshStateDataForeignMarkets(
            () => get().agricultureList,
            get().setAgricultureList,
            addr,
            symbolsGlobalCache
        );
    },
    refreshTopItems: async () => {
        await useSymbolsGlobalState.getState().refreshCache();
        const symbolsGlobalCache = useSymbolsGlobalState.getState().cache;
        await refreshStateDataForeignMarkets(
            () => get().topItems,
            get().setTopItems,
            topItemsAddr,
            symbolsGlobalCache
        );
    },
}));